import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { HttpService } from '../core/http.service';
import { environment } from '@base/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class RankingCategoriesGroupService extends HttpService {
  constructor(public override http: HttpClient) {
    super(http);
    this.url = '/ranking/categories/groups';
    this.baseUrl = environment.apiEndpoint;
  }
}
